module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"close":"Fermer"},"en":{"close":"Close"},"de":{"close":"Schließen"},"es":{"close":"Cerrar"},"it":{"close":"Chiudi"},"nl":{"close":"Sluiten"},"pt":{"close":"Fechar"}}')
  delete Component.options._Ctor
}
